<script>
import VSelect from '@alfsnd/vue-bootstrap-select';
import { BTable, BFormDatepicker, BInputGroup, BFormInput, BInputGroupAppend, BModal, BFormSelect } from 'bootstrap-vue'
import DibbleTranslation from "../../translation/translation";
import DibbleAPI from "../../api";
import DibbleJS from "../../dibble";
import Helper from '../../appHelper';

export default {
    name: "FeedbackReasons",
    components: {
        VSelect, BTable, BFormDatepicker, BFormSelect,
        BInputGroup, BFormInput, BInputGroupAppend, BModal
    },
    data() {
        return {            
            translate: DibbleTranslation,
            feedbackDetailsModal: {
                isOpen: false,
                isNew: true,
                title: DibbleTranslation.trans('pinker.editFeedbackReason'),
                reason: {
                    id: 0,
                    number: 0,
                    reason: 'Demo feedback reason',
                    isActive: true
                }
            },            
            showInfoModal: false,
            formUser:[],
            countries: [
                {
                    value: null,
                    text: "-- None --"
                }
            ],
            totalUser: 0,
            user_status: [],
            filter_from_date: '',
            filter_to_date: '',
            filter_to_date_formatted: '',
            filter_to_date_selected: '',
            search: {
                keyword: '',
                status: {},
                country: {
                    value: null,
                    text: "-- None --"
                },
            },
            fields: [
                { key: 'feedback_reason_id', label: DibbleTranslation.trans('pinker.feedbackReasonNumber'), sortable: true },
                { key: 'reason', label: DibbleTranslation.trans('pinker.feedbackReason'), sortable: true },
                { key: 'is_active', label: DibbleTranslation.trans('pinker.isActive'), sortable: true},
                { key: 'edit', label: DibbleTranslation.trans('pinker.edit'), sortable: false },
            ],
            selectedStatus: null,
            selectedLanguage: Helper.getAppLang(),
            statusOptions: [
                { value: null, text: DibbleTranslation.trans('pinker.selectFeedbackReasonStatus')},
                { value: true, text: DibbleTranslation.trans('pinker.active')},
                { value: false, text: DibbleTranslation.trans('pinker.inActive')}
            ],
            langOptions: [
                { value: 'he', text: DibbleTranslation.trans('pinker.Hebrew')},
                { value: 'en', text: DibbleTranslation.trans('pinker.English')}
            ],
            users: [],
            feedbacks: [],
            sourceFeedbacks: [],
            sourceUsers: [],
            pagination: {
                currentPage: 1,
                totalPage: 0
            },
            statisticForm: {
                isOpenStatisticModal: false,
                isAllApp: true,
                title: "",
                total_memo: 0,
                total_safe_memo: 0,
                total_space_memo: 0,
                total_ghost_memo: 0,
                total_complete_questionair: 0,
                total_share_memo: 0,
                total_report_to_user: 0,
                total_repost_from_user: 0,
                total_turnover_all: 0,
                total_turnover_each_subscription: 0,
            }
        }
    },
    mounted() {
        const scrollContent = document.getElementById('scroll-main-content')
        scrollContent.style.height = window.innerHeight*0.8 +  "px"
    },
    created() {
        this.loadFeedbackReasons();
    },
    methods: {
        moment(value) {
            return this.$moment(value)
        },
        showFeedbackModal(reasonItem, isNew) {
            this.feedbackDetailsModal.isNew = isNew;
            if (this.feedbackDetailsModal.isNew) {
                this.feedbackDetailsModal.title = this.translate.trans('pinker.createFeedbackReason')
                this.feedbackDetailsModal.reason.id = 0;
                this.feedbackDetailsModal.reason.reason = "";
                this.feedbackDetailsModal.reason.isActive = true;
            } else {
                this.feedbackDetailsModal.title = this.translate.trans('pinker.editFeedbackReason')
                this.feedbackDetailsModal.reason.id = reasonItem.feedback_reason_id;
                this.feedbackDetailsModal.reason.reason = reasonItem.reason;
                this.feedbackDetailsModal.reason.isActive = reasonItem.is_active;
            }
            this.feedbackDetailsModal.isOpen = true
        },
        saveReason () {            
            if (this.feedbackDetailsModal.isNew) {
                const params = {
                    '#request': DibbleAPI.api.admin.addFeedbackReason,
                    reason: this.feedbackDetailsModal.reason.reason,
                    language: Helper.getAppLang()
                };
                DibbleJS.showLoader();
                DibbleJS.callApiRequest(params, (responseData) => {
                    DibbleJS.hideLoader();
                    DibbleJS.toastErrorMessage(responseData.message);
                    if (DibbleAPI.isResponseSuccess(responseData)) {
                        this.loadFeedbackReasons();
                    }
                })
            } else {
                const params = {
                    '#request': DibbleAPI.api.admin.updateFeedbackReasons,
                    feedback_reason_id: this.feedbackDetailsModal.reason.id,
                    reason: this.feedbackDetailsModal.reason.reason,
                    is_active: this.feedbackDetailsModal.reason.isActive,
                    language: Helper.getAppLang()
                };
                DibbleJS.showLoader();
                DibbleJS.callApiRequest(params, (responseData) => {
                    DibbleJS.hideLoader();
                    DibbleJS.toastErrorMessage(responseData.message);
                    if (DibbleAPI.isResponseSuccess(responseData)) {
                        this.loadFeedbackReasons();
                    }
                })
            }
            this.feedbackDetailsModal.isOpen = false;
        },
        toggleCurrentReason () {
            this.feedbackDetailsModal.reason.isActive = !this.feedbackDetailsModal.reason.isActive            
        },
        closeFeedbackModal() {
            this.feedbackDetailsModal.isOpen = false
        },
        showBusinessProfile(userId) {
            alert(userId)
        },
        showFeedbacklist(userId) {
            alert(userId)
        },
        loadFeedbackReasons() {
            const params = {
                '#request': DibbleAPI.api.admin.getFeedbackReasons,
                sort_direction: false,
                language: Helper.getAppLang()
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, this._onLoadSuccess)
        },
        _onLoadSuccess(responseData) {
            DibbleJS.hideLoader();
            if (DibbleAPI.isResponseSuccess(responseData)) {
                this.sourceFeedbacks = responseData.feedbacks_reasons;
                this.feedbacks = responseData.feedbacks_reasons;
                // eslint-disable-next-line array-callback-return                
            } else {
                DibbleJS.toastErrorMessage(responseData.message);
            }
        },
        onlanguagechange() {
            Helper.setAppLang(this.selectedLanguage)
            this.loadFeedbackReasons()
        },
        filterReason () {
            if (this.selectedStatus == null) {
                this.feedbacks = this.sourceFeedbacks
            } else {
                const tempList = []
                this.sourceFeedbacks.map (item  => {
                    if ((item.is_active === 1) === this.selectedStatus) {
                        tempList.push(item)
                    }
                    return item;
                })
                this.feedbacks = tempList
            }
        },
        toggleActive (reasonItem) {
            let isActiveValue =  true;
            if (reasonItem.is_active === 1) {
                isActiveValue = false
            }
            const params = {
                '#request': DibbleAPI.api.admin.updateFeedbackReasonsStatus,
                feedback_reason_id: reasonItem.feedback_reason_id,
                is_active: isActiveValue
            };
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                DibbleJS.toastErrorMessage(responseData.message);
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.loadFeedbackReasons();
                }
            })
        },
        searchUser (searhKey) {
            const tempUserList = []
            this.sourceUsers.map((item, index) => {
                const fullname = item.first_name + item.last_name
                if (fullname.toLowerCase().includes(searhKey.toLowerCase()) 
                    || item.email.toLowerCase().includes(searhKey.toLowerCase())){
                        tempUserList.push(item)
                }
                return item;
            })
            this.users = tempUserList
        },
        showStatistic (dataItem, isAppStatistic) {
            this.statisticForm.isAllApp = isAppStatistic
            if (isAppStatistic) {
                this.statisticForm.title = this.translate.trans('users.statistic.title')+ ": " + this.translate.trans('users.statistic.all')
                console.log("isAppStatistic")
                this.loadAppStatistic((data) => {                
                    this.statisticForm.isOpenStatisticModal = true
                    this.statisticForm.total_memo = data.number_of_memories
                    this.statisticForm.total_safe_memo = data.number_of_safe_memories
                    this.statisticForm.total_space_memo = data.number_of_space_memories
                    this.statisticForm.total_ghost_memo = data.number_of_ghost_memories
                    this.statisticForm.total_share_memo = data.number_of_shared_memories
                    this.statisticForm.total_report_to_user = data.number_of_user_has_been_reported
                    this.statisticForm.total_repost_from_user = data.number_of_user_reported_other_users
                    this.statisticForm.total_complete_questionair = data.questionnaire_is_complete     
                    this.statisticForm.total_turnover_all = data.subscription     
                    this.statisticForm.total_turnover_each_subscription = data.subscription_plan     
                })
            } else {
                this.statisticForm.title = this.translate.trans('users.statistic.title') + ": " + dataItem.first_name + " " + dataItem.last_name
                this.loadUserStatistic(
                    dataItem.user_id, 
                    (data) => {                        
                        this.statisticForm.isOpenStatisticModal = true
                        this.statisticForm.total_memo = data.user_statistics.number_of_memories
                        this.statisticForm.total_safe_memo = data.user_statistics.number_of_safe_memories
                        this.statisticForm.total_space_memo = data.user_statistics.number_of_space_memories
                        this.statisticForm.total_ghost_memo = data.user_statistics.number_of_ghost_memories
                        this.statisticForm.total_share_memo = data.user_statistics.number_of_shared_memories
                        this.statisticForm.total_report_to_user = data.user_statistics.number_of_user_has_been_reported
                        this.statisticForm.total_repost_from_user = data.user_statistics.number_of_user_reported_other_users
                        this.statisticForm.total_complete_questionair = data.user_statistics.is_complete                        
                    }
                )
            }
        },
        loadUserStatistic (userId, callback) {
            DibbleJS.showLoader()
            const rq = {
                "#request": DibbleAPI.api.getUserStatistic,
                user_id: userId
            }
            DibbleJS.callApiRequest( 
                rq,
                (data) => {
                    DibbleJS.hideLoader()
                    if (DibbleAPI.isResponseSuccess(data)){
                        callback(data)
                    } else {
                        DibbleJS.toastErrorMessage(data.message)
                    }
                }
            )
        },
        loadAppStatistic (callback) {
            DibbleJS.showLoader()
            const rq = {
                "#request": DibbleAPI.api.getAllUserStatistic
            }
            DibbleJS.callApiRequest( 
                rq,
                (data) => {
                    DibbleJS.hideLoader()
                    if (DibbleAPI.isResponseSuccess(data)){
                        callback(data)
                    } else {
                        DibbleJS.toastErrorMessage(data.message)
                    }
                }
            )
        },
        closeStatisticModal () {
            this.statisticForm.isOpenStatisticModal = false
        },
        checkShowHeritageButton (item) {
            if ((item.timeline_email != null && item.timeline_email !== '') 
                || (item.safe_box_email != null && item.safe_box_email !== '')) {                    
                    return item.heritage_send_status
            } else {
                return ""
            }
        },
        updateHeritage (item) {
            const params = {
                "#request": DibbleAPI.api.sendHeritage,
                user_id: item.user_id
            };
            console.log(JSON.stringify(params))
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, 
            (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    DibbleJS.toastSuccessMessage(data.message);
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        cancelHeritage (item) {
            const params = {
                "#request": DibbleAPI.api.cancelSendHeritage,
                user_id: item.user_id
            };
            console.log(JSON.stringify(params))
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, 
            (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    DibbleJS.toastSuccessMessage(data.message);
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        toggleUserActive(item) {
            const params = {
              '#request': DibbleAPI.api.setUserActive,
              user_id: item.user_id,
              is_active: item.is_active === 0
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                  DibbleJS.toastSuccessMessage(responseData.message);
                  this.loadUsers();
                } else {
                  DibbleJS.toastErrorMessage(responseData.message);
                }
            })
        }
    }
}
</script>

<style>
    .user-image {
        width: 40px;
        height: 40px;
    }
    .v-dropdown-container {
        max-height: 250px;
        overflow-y: scroll;
    }
    .small-text-box {
        width: 50px
    }
    .medium-text-box {
        width: 120px
    }
    .circle-color {
        width: 20px;
        height: 20px;
        border-radius: 10px;
        background-color: brown;
    }  
</style>

<template src="./Templates/FeedbackReasons.html"></template>


